import { createFileRoute } from "@tanstack/react-router"
import { GoalsList } from "modules/campaigns/components/Sections/goals"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { GoalsFilterBySchema, GoalsSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const GoalsListSearchSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(GoalsSortSchema.shape.sortBy.unwrap())
  .merge(GoalsFilterBySchema)

export const Route = createFileRoute("/_base/_auth/campaigns/goals/list")({
  component: GoalsList,
  validateSearch: (search: Partial<z.infer<typeof GoalsListSearchSchema>>) => {
    search.filterBy = search.filterBy || {}
    return GoalsListSearchSchema.parse(search)
  },
})
